export default __webpack_public_path__ + "static/media/Incidents - Inner page.f5c29ec4.png";